import { Link } from "wouter";
import { Boton } from "@/components/ui";
import { Logo } from "@/components/layout/Logo";

/** Miembro con consentimiento pero con el acceso todavía cerrado: en vez de una app que falla en cada pantalla, una espera clara. */
export function ListaDeEspera({ salir }: { salir: () => void }) {
  return (
    <main className="mx-auto flex min-h-full max-w-md flex-col gap-5 p-6">
      <Logo tono="claro" />
      <h1 className="text-2xl font-semibold">Tu lugar está apartado</h1>
      <p className="text-[15px] leading-snug text-tinta">Tu correo ya está en la lista de Wealth Nation y aceptaste el aviso de privacidad. El asesor se abre a los miembros en unos días; te avisamos por correo y en la comunidad.</p>
      <p className="text-[15px] leading-snug text-tinta-suave">Mientras, puedes ver cómo funciona con el ejemplo de Henry: su foto, su asesor y sus tres reportes.</p>
      <Link href="/ejemplo"><Boton tamano="lg" className="w-full">Ver el ejemplo</Boton></Link>
      <Boton variante="fantasma" onClick={salir}>Salir</Boton>
    </main>
  );
}
